<template>
	<div class="deviceSurvey-wrap" v-if="kind == 10">
		<div class="survey">
			<h3 class="mb-3" style="font-size: 18px;">{{ surveyData.location }}</h3>
			<p class="code f12 mb-2">设备ID：{{ surveyData.code }}</p>
			<div class="survey-top">
				<img v-if="surveyData.type === 10" src="~@/assets/device.png" />
				<img v-if="surveyData.type === 20" src="~@/assets/sb.png" />
				<img v-if="surveyData.type === 30" src="~@/assets/lqt.png" />
				<div class="detail ml-3">
					<p>机组名称：{{ surveyData.unit_name }}</p>
					<p>安装楼层：{{ surveyData.floor }}</p>
					<p>系统名称：{{ surveyData.system }}</p>
					<p>设备型号：{{ surveyData.device_model }}</p>
					<p>设备功率：{{ surveyData.power }} kW</p>
					<p>制冷量：{{ surveyData.cool_energy }} kW</p>
					<!-- <p>当前水流量：{{surveyData.}}</p> -->
					<!-- <p>标准水流量：{{surveyData.}}</p> -->
				</div>
			</div>
			<div class="survey-bottom mt-3">
				<div v-if="surveyData.sjsj !== undefined">
					<h3 class="mb-1 fb">运行数据</h3>
					<p>采集时间：{{ surveyData.sjsj }}</p>
					<p>室内温度：{{ surveyData.snwd }} ℃</p>
					<p>室内湿度：{{ surveyData.snsd }} ％</p>
					<p>运行电流：{{ surveyData.yjdl }} A</p>
					<p>设备状态：{{ surveyData.kgjzt === 0 ? '关' : '开' }}</p>
					<p>压机1状态：{{ surveyData.yj1zt === 0 ? '关' : '开' }}</p>
					<p>压机2状态：{{ surveyData.yj2zt === 0 ? '关' : '开' }}</p>
					<p>电加热状态：{{ surveyData.djrzt === 0 ? '关' : '开' }}</p>
					<p>故障代码：{{ surveyData.bjxh }}</p>
					<p v-if="surveyData.control_panel_type == 40">当前水流量：{{ surveyData.sll }} m³/h</p>
					<p v-if="surveyData.control_panel_type == 40">球阀开度：{{ surveyData.qfkd }} %</p>
				</div>
				<div>
					<h3 class="mb-1 fb">数据统计</h3>
					<p>开机时长：{{ (surveyData.kjsc / 60).toFixed(2) }} h</p>
					<p>压机1运行时长：{{ (surveyData.yj1sc / 60).toFixed(2) }} h</p>
					<p>压机2运行时长：{{ (surveyData.yj2sc / 60).toFixed(2) }} h</p>
					<p>电加热运行时长：0 h</p>
					<p>用能：{{ surveyData.dnsj }} kW·h</p>
				</div>
			</div>
		</div>
	</div>

	<!-- <div class="deviceSurvey-wrap" v-else>
		<div class="survey mb-2">
			<h3 class="f18 fb">{{ surveyData.location }}</h3>
			<p class="code f12 mb-1">设备ID：{{ surveyData.SBID }}</p>
			<div class="survey-top">
				<img src="~@/assets/sb.png" />
				<div class="detail ml-3">
					<p>机组名称：{{ surveyData.name }}</p>
					<p>安装楼层：{{ surveyData.floor }}</p>
					<p>设备型号：{{ surveyData.pump_mode }}</p>
					<p>设备功率：{{ surveyData.power }} kW</p>
				</div>
			</div>
			<div class="survey-bottom mt-3">
				<div v-if="surveyData.SJSJ !== undefined">
					<h3 class="mb-1 fb">运行数据</h3>
					<p>采集时间：{{ surveyData.SJSJ }}</p>
					<p>运行频率：{{ surveyData.YXPL }}</p>
					<p>风机电流：{{ surveyData.FJDL }} A</p>
				</div>
			</div>
		</div>
	</div> -->
</template>

<script>
	export default {
		props: ['code', 'kind'],
		watch: {
			'code': {
				handler() {
					this.getDeviceSurvey();
				},
			},
			deep: true
		},
		data() {
			return {
				surveyData: {},
			}
		},

		// 全局vue.js不强制刷新或者重启时只创建一次,也就是说,created()只会触发一次
		created() {
			this.init();
		},

		// 进入当前存在activated()函数的页面时,一进入页面就触发,可以用于列表数据等的刷新
		activated() {
			//
		},

		// 通常是初始化页面完成后，再对html的dom节点进行一些需要的操作
		mounted() {
			//
		},
		methods: {
			init() {
				if (this.kind == 10) {
					this.getDeviceSurvey();
				} else if (this.kind == 20) {
					this.getPumpSurvey();
				}
			},

			generateData(o) {
				this.timeConfig = Object.assign(this.timeConfig, o);
				this.tableConfig.loading = true;
			},

			async getDeviceSurvey() {
				let dataObj = {
					deviceCode: this.code
				}
				await this.$axios.get("/api/airConditions/survey", {
					params: dataObj
				}).then(res => {
					this.surveyData = res.data.data
				})
			},

			async getPumpSurvey() {
				let dataObj = {
					deviceCode: this.code
				}
				await this.$axios.get("/api/pumps/currentRunning", {
					params: dataObj
				}).then(res => {
					this.surveyData = res.data.data;
					this.form.switch = res.data.data.KGJ;
					this.form.yxpl = res.data.data.YXPL;
				})
			},
			// async getRuntimeEnergy() {
			// 	let [err, data] = await this.$to(
			// 		runtimeEnergy({
			// 			data: {
			// 				deviceCode: this.code,
			// 				startTime: `${this.timeConfig.startDay} 00:00:00`,
			// 				endTime: `${this.timeConfig.endDay} 23:59:59`
			// 			}
			// 		})
			// 	);
			// 	if (err) {
			// 		return;
			// 	}
			// 	this.tableConfig.tableData = data;
			// 	this.tableConfig.loading = false;
			// },
		}
	}
</script>

<style lang="scss">
	.deviceSurvey-wrap {
		width: 100%;

		.survey {
			padding: 20px 30px;
			background-color: #fff;

			.code {
				color: #666;
			}

			.survey-top {
				display: flex;

				img {
					width: 250px;
					height: 168px;
				}

				.detail {
					color: #666;
					line-height: 28px;
					display: flex;
					flex-wrap: wrap;
					align-items: flex-start;

					p {
						width: 100%;
					}
				}
			}

			.survey-bottom {
				display: flex;

				div {
					width: 30%;
					margin-right: 10%;
					color: #666;
					line-height: 28px;

					h3 {
						height: 40px;
						padding-left: 15px;
						line-height: 38px;
						border: 1px solid #e1e6eb;
						background: #f5f6fa;
						border-left: 4px solid #6d7781;
					}
				}
			}
		}
	}
</style>
